import { render, staticRenderFns } from "./equipamentos.vue?vue&type=template&id=295ab298"
import script from "./equipamentos.vue?vue&type=script&lang=js"
export * from "./equipamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports